angular.module('country')
    .controller('CountryDialogController', function ($rootScope, $uibModalInstance, data, toastr, Country, CountryConst) {
        this.$onInit = () => {
            this.item = data
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = Country.update(this.item).$promise
            } else {
                promise = Country.save(this.item).$promise
            }
            return promise.then(result => {
                $uibModalInstance.close(result)
                $rootScope.$broadcast(CountryConst.eventUpdate)
                toastr.success("Zapisano")
            })
        }
        this.onDefaultChange = (region) => {
            angular.forEach(this.item.regions, (value, key) => {
                if (value !== region)
                    value.defaults = false
            })
        }
    })
